import { apiFetch } from './apiFetch';

// Domyślnie ten sam origin co front (nginx proxuje /api/ na backend). Bez fallbacku
// brak zmiennej dawał adresy typu "undefined/panels/" — cichy błąd w przeglądarce.
const apiUrl = process.env.REACT_APP_API_URL || '/api/';

export const fetchProducts = async (url) => {
  try {
    const response = await apiFetch(`${apiUrl}${url}`);

    if (!response.ok) {
      throw new Error('Failed to fetch data.');
    }

    return await response.json();

  } catch (error) {
    console.error('Error fetching products!', error);
    throw error;
  }
};

// Ten sam mapping co ENDPOINT w hooks/useProductModels.js — celowo zduplikowany
// tu, nie zaimportowany stamtąd, bo ten plik jest niżej w grafie zależności
// (hook importuje Z NIEGO, nie na odwrót).
const MODEL_ENDPOINT = {
  panel: 'panel_models',
  inwerter: 'inverter_models',
  magazyn: 'magazine_models',
};

// Serie dla JEDNEGO producenta — zasila filtr „Seria" w Filters.jsx, który
// pojawia się dopiero po wybraniu dokładnie jednego. Zwraca [] po błędzie:
// brak serii nie ma blokować reszty filtrów.
export const fetchSeriesOptions = async (productType, manufacturer) => {
  const endpoint = MODEL_ENDPOINT[productType];
  if (!endpoint || !manufacturer) return [];
  try {
    const res = await apiFetch(`${apiUrl}${endpoint}/series_options?manufacturer=${encodeURIComponent(manufacturer)}`);
    if (!res.ok) return [];
    const data = await res.json();
    return data.series || [];
  } catch {
    return [];
  }
};

// // Fetch details of a single product by ID
// export const fetchProductDetails = async (productId) => {
//   try {
//     const response = await apiFetch(`${apiUrl}get_panel/${productId}`);
//     if (!response.ok) {
//       throw new Error('Failed to fetch product details.');
//     }
//     return await response.json();
//   } catch (error) {
//     console.error('Error fetching product details!', error);
//     throw error;
//   }
// };

// // Fetch similar products based on a product ID
// export const fetchSimilarProducts = async (productId) => {
//   try {
//     const response = await apiFetch(`${apiUrl}similar_products_panels/${productId}`);
//     if (!response.ok) {
//       throw new Error('Failed to fetch similar products.');
//     }
//     return await response.json();
//   } catch (error) {
//     console.error('Error fetching similar products!', error);
//     throw error;
//   }
// };